<div #tooltipBox class="guide-overlay" *ngIf="overlay" [style.top.px]="overlay.top" [style.left.px]="overlay.left"
  (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" (mouseenter)="guide.setOverlayHovered(true)"
  (mouseleave)="guide.setOverlayHovered(false)">

  <div class="guide-main-card">
    <div [ngClass]="{
    'guide-img-container': overlay.step.customfield1
  }" *ngIf="overlay.step.imageUrl || overlay.step.customfield1 || guide.tourVideoLink || overlay.step.videoLink">
      <!-- Image Rendering -->
      <img *ngIf="overlay.step.customfield1" [src]="serverPathNew + (overlay.step.customfield1) + cid"
        class="guide-hero-image" alt="Tour Step Image">

      <!-- Video Overlay -->
      <div class="video-overlay" *ngIf="guide.tourVideoLink || overlay.step.videoLink"
        (click)="playVideo(guide.tourVideoLink || overlay.step.videoLink)">
        <mat-icon>play_circle_filled</mat-icon>
      </div>
    </div>
    <div class="guide-content">
      <div class="guide-text-area">
        <h3 class="guide-title d-flex align-items-center justify-content-between">
          <span>{{ overlay.step.title || overlay.step.imageLinkUrl }}</span>
          <button mat-icon-button *ngIf="guide.tourVideoLink || overlay.step.videoLink" class="video-btn-sm"
            (click)="playVideo(guide.tourVideoLink || overlay.step.videoLink)" title="Watch Video">
            <mat-icon>play_circle</mat-icon>
          </button>
        </h3>
        <p class="guide-desc" [innerHTML]="overlay.step.imageUrl"></p>
      </div>

      <div class="guide-footer">

        <div class="guide-footer-left">
          <div class="guide-dots">
            <span *ngFor="let i of visibleSteps" class="dot" [class.active]="i === guide.currentIndex"></span>
          </div>
          <button [attr.guide]="'step-guide-btn-1' + '__' + sanitizeUrl(url)" class="btn-skip"
            (click)="guide.skip()">Skip Tour</button>
        </div>

        <div class="guide-footer-right">
          <button [attr.guide]="'step-guide-btn-2' + '__' + sanitizeUrl(url)" class="nav-item" (click)="guide.prev()"
            [disabled]="guide.currentIndex === 0" [class.disabled]="guide.currentIndex === 0">
            <div class="nav-icon-circle">
              <mat-icon>chevron_left</mat-icon>
            </div>
            <span class="nav-text">Previous</span>
          </button>

          <button [attr.guide]="'step-guide-btn-3' + '__' + sanitizeUrl(url)" class="nav-item" (click)="guide.next()">
            <div class="nav-icon-circle active">
              <mat-icon *ngIf="guide.currentIndex !== guide.steps.length - 1">chevron_right</mat-icon>
              <mat-icon *ngIf="guide.currentIndex === guide.steps.length - 1">check</mat-icon>
            </div>
            <span class="nav-text">{{ guide.currentIndex === guide.steps.length - 1 ? 'Finish' : 'Next' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="guide-side-panel" [attr.data-panel-position]="overlay.panelPosition" [class.stacked]="isStacked"
    [class.side]="!isStacked"
    [class.show-panel]="((guide.showSidePanel$ | async) || overlay.step.showRightPanelOn === 'always') && (overlay.step.text || (overlay.step.rightPanelBullets && overlay.step.rightPanelBullets.length))">
    <div class="guide-side-content">
      <h4 *ngIf="overlay.step.rightPanelTitle">{{ overlay.step.rightPanelTitle }}</h4>

      <div class="agNoteCont" *ngIf="overlay.step.text">
        <div #sidePanelDesc [innerHTML]="overlay.step.text" class="guide-html-body truncated"
          [class.full-content]="!isTruncated"></div>
        <a *ngIf="isTruncated" [attr.guide]="'step-guide-lnk-4' + '__' + sanitizeUrl(url)" class="view-more-link"
          (click)="toggleDetails()">View More</a>
      </div>

      <div class="agNoteCont" *ngIf="overlay.step.rightPanelBullets && overlay.step.rightPanelBullets.length">
        <ul>
          <li *ngFor="let bullet of overlay.step.rightPanelBullets">
            <span class="bullet-icon">•</span> <span [innerHTML]="bullet"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="guide-details-modal" *ngIf="showDetailsModal" (click)="toggleDetails()">
    <div class="guide-modal-content" (click)="$event.stopPropagation()">
      <button [attr.guide]="'step-guide-btn-5' + '__' + sanitizeUrl(url)" class="btn-close-modal"
        (click)="toggleDetails()">×</button>

      <h2 *ngIf="overlay.step.imageLinkUrl || overlay.step.title">{{ overlay.step.imageLinkUrl || overlay.step.title }}
      </h2>

      <div class="modal-body-scroll">
        <div [innerHTML]="overlay.step.text" class="guide-html-body full"></div>

        <div class="agNoteCont" *ngIf="overlay.step.rightPanelBullets && overlay.step.rightPanelBullets.length">
          <ul>
            <li *ngFor="let bullet of overlay.step.rightPanelBullets">
              <span class="bullet-icon">•</span> <span [innerHTML]="bullet"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="guide-arrow" [attr.data-position]="overlay.position"
    [style.left.px]="(overlay.position === 'top' || overlay.position === 'bottom') ? overlay.arrowPosition?.left : null"
    [style.top.px]="(overlay.position === 'left' || overlay.position === 'right') ? overlay.arrowPosition?.top : null">
  </div>
</div>

<div class="guide-notification" *ngIf="notification">
  <span>{{ notification }}</span>
</div>

<div class="guide-backdrop" *ngIf="overlay" (click)="$event.stopPropagation()"></div>

<div class="recorder-ui" *ngIf="guide.isRecording" cdkDrag (mousedown)="$event.stopPropagation()">
  <span class="recorder-badge" cdkDragHandle>● Recording...</span>
  <button [attr.guide]="'step-guide-btn-6' + '__' + sanitizeUrl(url)" class="btn-stop" (click)="guide.stopRecording()">
    Stop
  </button>
</div>